// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/agent/planning.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PlanSimulation, PlanSimulation_Target } from "../../types/tasks";

export const protobufPackage = "api.devplan.services.agent.planning";

export interface GetPlanSimulationsRequest {
  companyId: number;
  targets: PlanSimulation_Target[];
}

export interface GetPlanSimulationsResponse {
  simulations: PlanSimulation[];
}

function createBaseGetPlanSimulationsRequest(): GetPlanSimulationsRequest {
  return { companyId: 0, targets: [] };
}

export const GetPlanSimulationsRequest: MessageFns<GetPlanSimulationsRequest> = {
  encode(message: GetPlanSimulationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    for (const v of message.targets) {
      PlanSimulation_Target.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlanSimulationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlanSimulationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.targets.push(PlanSimulation_Target.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlanSimulationsRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      targets: globalThis.Array.isArray(object?.targets)
        ? object.targets.map((e: any) => PlanSimulation_Target.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPlanSimulationsRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.targets?.length) {
      obj.targets = message.targets.map((e) => PlanSimulation_Target.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetPlanSimulationsRequest>): GetPlanSimulationsRequest {
    return GetPlanSimulationsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPlanSimulationsRequest>): GetPlanSimulationsRequest {
    const message = createBaseGetPlanSimulationsRequest();
    message.companyId = object.companyId ?? 0;
    message.targets = object.targets?.map((e) => PlanSimulation_Target.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPlanSimulationsResponse(): GetPlanSimulationsResponse {
  return { simulations: [] };
}

export const GetPlanSimulationsResponse: MessageFns<GetPlanSimulationsResponse> = {
  encode(message: GetPlanSimulationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.simulations) {
      PlanSimulation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlanSimulationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlanSimulationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.simulations.push(PlanSimulation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlanSimulationsResponse {
    return {
      simulations: globalThis.Array.isArray(object?.simulations)
        ? object.simulations.map((e: any) => PlanSimulation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPlanSimulationsResponse): unknown {
    const obj: any = {};
    if (message.simulations?.length) {
      obj.simulations = message.simulations.map((e) => PlanSimulation.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetPlanSimulationsResponse>): GetPlanSimulationsResponse {
    return GetPlanSimulationsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPlanSimulationsResponse>): GetPlanSimulationsResponse {
    const message = createBaseGetPlanSimulationsResponse();
    message.simulations = object.simulations?.map((e) => PlanSimulation.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
